import { render, staticRenderFns } from "./BookingChargesModal.vue?vue&type=template&id=eb28746c&scoped=true"
import script from "./BookingChargesModal.vue?vue&type=script&lang=js"
export * from "./BookingChargesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb28746c",
  null
  
)

export default component.exports